<template>
  <zpa-form-item
    :error="error"
    :success="success"
    :validating="validating"
    :required="required"
    :readonly="readonly"
    :disabled="disabled"
    :uuid="uuid"
    :span="span"
    :push="push"
    :label="showLabel?label:''"
    :labelWidth="labelWidth"
    :labelAlign="labelAlign"
    :itemHeight="itemHeight"
  >
    <i-select
      :value="renderValue"
      :multiple="multiple"
      :clearable="clearable"
      :filterable="filterable"
      :readonly="readonly"
      :disabled="disabled"
      :placeholder="placeholder?placeholder:label"
      @on-change="onInputChange"
    >
      <i-option
        v-for="(v, i) in renderValues"
        v-show="!v._hide"
        :key="i"
        :value="getValue(v)"
        :label="getText(v)"
      >
        <zpa-row middle>
          <TreeHandler
            :value="v"
            @update="onUpdate"
          />
          {{getText(v)}}
        </zpa-row>
      </i-option>
    </i-select>
  </zpa-form-item>
</template>

<script>
import inputMixin from './mixins/input'
import queryMixin from './mixins/query'
import valueTextMixin from './mixins/value-text'
import stringifyMixin from './mixins/stringify'
import {flatTree} from '../utils'
import TreeHandler from './tree-handler'

export default {
  name: 'zpaTreeSelect',

  mixins: [
    inputMixin,
    queryMixin,
    valueTextMixin,
    stringifyMixin,
  ],

  components: {
    TreeHandler,
  },

  data() {
    return {
      trees: [],
    }
  },

  props: {
    value: [String, Array, Number],

    values: Array,

    multiple: Boolean,

    clearable: Boolean,

    filterable: {type: Boolean, default: true},
  },

  computed: {
    type() {
      return this.multiple ? 'array' : 'string'
    },
  },

  methods: {
    getText2(v) {
      // console.log(v,222222222222)
    },
    onUpdate(values = this.trees) {
      if (!values) {
        this.renderValues = []
        return
      }

      this.renderValues = flatTree(values)

      // console.log(this.renderValues, 3333333333)
    },

    async reload() {
      if (this.query) {
        this.isLoading = true
        this.trees = await this.query()
        this.onUpdate()
        this.isLoading = false
      }
    },
  },

  watch: {
    values: {
      handler(values) {
        this.trees = values
        this.onUpdate()
      },
      immediate: true,
    },
  },
}
</script>
